import api from '@/services/api'

export const getGoalFeed = async targetId => {
    try {
        const resp = await api.get(`goals/${targetId}/feed`, {
            params: {
                with: 'user;comment;artifact;details;kpiCheckin',
            },
        })
        return await resp.data
    } catch (error) {
        console.error(error)
    }
}
